"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const redux_1 = require("redux");
const activePopover = (state = '', action) => {
    if (action.type === 'UPDATE_ACTIVE_POPOVER') {
        return action.field;
    }
    return state;
};
const isPopoverModalFormOpen = (state = 'close', action) => {
    switch (action.type) {
        case 'OPEN_POPOVER_MODAL_FORM':
            return 'open';
        case 'CLOSE_POPOVER_MODAL_FORM':
            return 'close';
        case 'CLOSING_POPOVER_MODAL_FORM':
            return 'closing';
        default:
            return state;
    }
};
exports.default = redux_1.combineReducers({
    activePopover,
    isPopoverModalFormOpen,
});
exports.getActivePopover = (state) => state.activePopover;
exports.getIsPopoverModalFormOpen = (state) => state.isPopoverModalFormOpen;
